import React from 'react';
import { Filter, Zap, Send } from 'lucide-react';
import { Button } from '../shared/Button';
export function VSLSteps() {
  const steps = [{
    icon: <Filter className="w-8 h-8 text-[#3ab795]" data-id="element-2517" />,
    title: '1. Filter Motivated Listings',
    description: 'Set your buy box once. Our AI scans the MLS 24/7 for properties that match your exact criteria.'
  }, {
    icon: <Zap className="w-8 h-8 text-[#3ab795]" data-id="element-2518" />,
    title: '2. Auto-Generate Offers',
    description: 'The system calculates your max allowable offer based on your rules and generates the paperwork instantly.'
  }, {
    icon: <Send className="w-8 h-8 text-[#3ab795]" data-id="element-2519" />,
    title: '3. Send at Scale',
    description: 'Send hundreds or thousands of offers automatically. Agents get a professional offer in their inbox.'
  }];
  return <section className="w-full bg-[#0a0a0a] py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-2520">
      {/* Green glow */}
      <div className="absolute bottom-0 left-0 w-full max-w-3xl h-96 bg-[#3ab795] opacity-5 blur-[150px] rounded-full pointer-events-none" data-id="element-2521" />

      <div className="max-w-6xl mx-auto" data-id="element-2522">
        <div className="text-center mb-16" data-id="element-2523">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-2524">
            How It Works
          </h2>
          <p className="text-[#b8bcc8] text-lg" data-id="element-2525">
            Set your rules once. Let the system run daily.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16 relative z-10" data-id="element-2526">
          {steps.map((step, index) => <div key={index} className="bg-[#121212] border border-white/5 rounded-2xl p-8 hover:border-[#3ab795]/30 transition-colors duration-300 group" data-id="element-2527">
              <div className="w-16 h-16 bg-[#3ab795]/10 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-2528">
                {step.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-2529">
                {step.title}
              </h3>
              <p className="text-[#b8bcc8] leading-relaxed" data-id="element-2530">
                {step.description}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-2531">
          <Button variant="outline" size="lg" className="border-[#3ab795] text-[#3ab795] hover:bg-[#3ab795] hover:text-white" href="https://calendly.com/acquireflow/strategy" data-id="element-2532">
            See If This Works In My Market
          </Button>
        </div>
      </div>
    </section>;
}